import React, { Component } from 'react';
import './AccountTerms.css';

class AccountTerms extends Component {
  render() {
    return (
      <div className="AccountTerms">
        <div className="contents">
          <h1 style={{ alignSelf: "center", fontFamily: "NanumBarunGothicBold" }}>
            계정 삭제 안내
          </h1>

          <br />

          <span id="section1">
            본 안내는 레몬케이크(이하 “회사”)가 제공하는 도서 리뷰 및 회원 간 채팅
            서비스 플랫폼 “자정의 도서관”(이하 “서비스”)에서 생성되는 사용자
            계정 및 사용자 식별 정보의 삭제 절차와 개인정보 처리에 관한 사항을
            설명하기 위한 것입니다.
          </span>

          <br /><br />

          <span className="first">제1조 (계정 및 사용자 식별 정보 생성 방식)</span><br />
          <span className="second">
            본 서비스는 카카오, 네이버, 구글 계정을 이용한 OAuth 로그인 방식을
            통해 회원 계정을 생성합니다.
          </span><br />
          <span className="second">
            또한, 로그인하지 않고 서비스를 이용하는 경우에도 서비스 이용을
            위해 임시 사용자 식별 정보(게스트 계정)가 생성될 수 있습니다.
          </span>

          <br /><br />

          <span className="first">제2조 (계정 삭제 방법)</span><br />
          <span className="second">
            회원 및 게스트 이용자는 언제든지 계정 또는 사용자 식별 정보의 삭제를
            요청할 수 있습니다.
          </span>
          <ul>
            <li className="third">앱 실행</li>
            <li className="third">설정 메뉴 진입</li>
            <li className="third">계정 삭제 선택</li>
            <li className="third">안내에 따라 삭제 절차 진행</li>
          </ul>
          <span className="second">
            앱 이용이 어려운 경우, 아래 문의처를 통해 계정 또는 사용자 식별
            정보의 삭제를 요청할 수 있습니다.
          </span>

          <br /><br />

          <span className="first">제3조 (삭제되는 정보)</span><br />
          <ul>
            <li className="third">OAuth 로그인 계정 정보 또는 게스트 식별 정보</li>
            <li className="third">프로필 정보</li>
            <li className="third">작성한 게시글 및 댓글</li>
            <li className="third">채팅 기록</li>
            <li className="third">서비스 이용 기록</li>
          </ul>

          <br /><br />

          <span className="first">제4조 (보관되는 정보)</span><br />
          <span className="second">
            관련 법령에 따라 다음 정보는 일정 기간 보관될 수 있습니다.
          </span>
          <ul>
            <li className="third">전자상거래 및 소비자 보호 관련 기록</li>
            <li className="third">법령에 따른 분쟁 해결 및 증빙 자료</li>
          </ul>

          <br /><br />

          <span className="first">제5조 (처리 기간)</span><br />
          <span className="second">
            계정 또는 사용자 식별 정보 삭제 요청 시 즉시 처리가 시작되며,
            모든 정보는 최대 7일 이내에 완전히 삭제됩니다.
          </span>

          <br /><br />

          <span className="first">제6조 (문의처)</span><br />
          <span className="second">
            계정 삭제와 관련한 문의는 아래 이메일을 통해 접수하실 수 있습니다.
          </span><br />
          <span className="second">
            이메일: help.lemoncake@gmail.com
          </span>

          <br /><br />

          <span className="first">부칙</span><br />
          <span className="second">
            본 안내는 2025년 5월 1일부터 적용됩니다.
          </span>
        </div>
      </div>
    );
  }
}

export default AccountTerms;